












































import { AdgroupFormData, CampaignFormData, MAX_RULES_COUNT, RulesType } from '@tt4b/ttam-enums';
import { computed, defineComponent, nextTick, onBeforeMount, PropType, Ref, ref, toRefs } from '@vue/composition-api';
import TtamAudienceRules from '../components/audience-rules/index.vue';
import { Validator } from '../types';
import { useAppEventDataSource, useAudienceRules, useAudienceEventRules } from '../hooks';

const name = 'ttam-audience-event-select';
export default defineComponent({
  name,
  components: {
    TtamAudienceRules,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData } = toRefs(props);
    const daysOptions = ref([2, 3, 4, 7, 14, 30, 60, 90, 180]);
    const maxRulesCount = ref(MAX_RULES_COUNT);

    const _retargetingEventInclude = computed({
      get: () => adgroupData.value.retargetingEventInclude,
      set: val => {
        emit('include-event-change', val);
      },
    });
    const _retargetingEventExclude = computed({
      get: () => adgroupData.value.retargetingEventExclude,
      set: val => {
        emit('exclude-event-change', val);
      },
    });

    const {
      rules: inCludeRules,
      add: addInclude,
      remove: removeInclude,
      update: updateIncludeRules,
    } = useAudienceRules({
      minRulesCount: 1,
      maxRulesCount: maxRulesCount.value,
      initRules: computed(() => adgroupData.value.retargetingEventInclude),
    });
    const {
      rules: exCludeRules,
      add: addExclude,
      remove: removeExclude,
      update: updateExcludeRules,
    } = useAudienceRules({
      minRulesCount: 0,
      maxRulesCount: maxRulesCount.value,
      initRules: computed(() => adgroupData.value.retargetingEventExclude),
    });

    const retargetingEventSelect: Ref<Validator | null> = ref(null);
    const onIncludeChange = (type: string, value) => {
      const { index, val } = value || {};
      if (type === 'add') {
        addInclude();
      }
      if (type === 'remove') {
        removeInclude(index as number);
      }
      if (type === 'change') {
        updateIncludeRules(index, val);
      }
      emit('include-event-change', [...inCludeRules.value]);
      nextTick(() => {
        retargetingEventSelect.value && retargetingEventSelect.value.validate('change');
      });
    };
    const onExcludeChange = (type: string, value) => {
      const { index, val } = value || {};
      if (type === 'add') {
        addExclude();
      }
      if (type === 'remove') {
        removeExclude(index as number);
      }
      if (type === 'change') {
        updateExcludeRules(index, val);
      }
      emit('exclude-event-change', [...exCludeRules.value]);
      nextTick(() => {
        retargetingEventSelect.value && retargetingEventSelect.value.validate('change');
      });
    };

    const { includeErrors, excludeErrors } = useAudienceEventRules();

    const createRulesItem = (): RulesType => ({ code: '', days: '' });
    const { appEventList } = useAppEventDataSource({ adgroupData });
    const actionsOptions = computed(() =>
      appEventList?.value?.map(item => ({
        label: item.NameI18n || item.Enum,
        value: item.Enum,
      })),
    );
    onBeforeMount(() => {
      if (!_retargetingEventInclude.value?.length) {
        const rulesItem = createRulesItem();
        _retargetingEventInclude.value = [rulesItem];
      }
    });
    return {
      name,
      daysOptions,
      maxRulesCount,
      _retargetingEventInclude,
      _retargetingEventExclude,
      actionsOptions,
      includeErrors,
      excludeErrors,
      onIncludeChange,
      onExcludeChange,
    };
  },
});
